// extracted by mini-css-extract-plugin
export var bubble = "_3f-0";
export var container = "_3f-f";
export var contrastBorder = "_3f-g";
export var greyOut = "_3f-2";
export var initialsColor0 = "_3f-3";
export var initialsColor1 = "_3f-4";
export var initialsColor10 = "_3f-d";
export var initialsColor11 = "_3f-e";
export var initialsColor2 = "_3f-5";
export var initialsColor3 = "_3f-6";
export var initialsColor4 = "_3f-7";
export var initialsColor5 = "_3f-8";
export var initialsColor6 = "_3f-9";
export var initialsColor7 = "_3f-a";
export var initialsColor8 = "_3f-b";
export var initialsColor9 = "_3f-c";
export var initialsWrapper = "_3f-1";
export var large = "_3f-l";
export var medium = "_3f-k";
export var mediumSmall = "_3f-j";
export var mediumSmallMedium = "_3f-o";
export var micro = "_3f-h";
export var small = "_3f-i";
export var tiny = "_3f-n";
export var xTiny = "_3f-m";